import { render, staticRenderFns } from "./Ampliados.vue?vue&type=template&id=7381cb7e"
import script from "./Ampliados.vue?vue&type=script&lang=js"
export * from "./Ampliados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports